import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["event"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import Cookies from 'js-cookie';
var counterId;
export function setCounterId(stage) {
  if (stage === 'production') {
    counterId = 4173733;
  } else {
    counterId = 87713619;
  }
}
var user_id = Cookies.get('userId') || undefined;
export default (function (func) {
  return function () {
    var _func = func.apply(void 0, arguments),
        event = _func.event,
        analytic = _objectWithoutProperties(_func, _excluded);

    if (window && window.ym) {
      window.ym(counterId, 'reachGoal', event, _objectSpread(_objectSpread({
        event_name: event
      }, analytic), {}, {
        user_id: user_id
      }));
    }
  };
});